import { mapGetters, mapActions } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            isMobile: 'ui/isMobile',
            viewportHeight: 'ui/viewportHeight',
            recommendation: 'ui/recommendation',
            feedback: 'ui/feedback',
            mapActive: 'ui/map',
            translation: 'ui/translation',
            detectedLanguage: 'ui/detectedLanguage',
            myCoords: 'ui/currentCoordinates'
        })
    },
    methods: {
        ...mapActions('ui', [
            'setRecommendation',
            'setFeedback',
            'setMap',
            'setTranslation',
            'setCurrentLanguage',
            'setCurrentCoordinates'
        ]),
        capitalizeFirstLetter(s) {
            return s.charAt(0).toUpperCase() + s.slice(1)
        }
    }
}
